import { encode, decode } from "helpers/secrets"

class Language { }

Language.setLanguage = data => {
  var data = {
    lng: data,
  }
  localStorage.setItem("lng", encode(JSON.stringify(data)))
}

Language.getLanguage = () => {
  let data = localStorage.getItem("lng")
  var cData = null
  if (data && data !== "null" && data !== undefined) {
    cData = JSON.parse(decode(data))
  }
  return cData
}
Language.setTranslate = data => {
  localStorage.setItem("translate", JSON.stringify(data))
}

Language.getTranslate = () => {
  let data = localStorage.getItem("translate")
  var cData = null
  if (data && data !== "null" && data !== undefined) {
    cData = JSON.parse(data)
  }
  return cData
}
let translate_data = null
let selected_lng = null
Language.ts = (_key_word, keyIsTH = true) => { // translate
  // console.log("translate : ", _key_word)
  if (_key_word == undefined) return ""
  if (translate_data == null) {
    let data = localStorage.getItem("translate")
    if (data && data !== "null" && data !== undefined) {
      translate_data = JSON.parse(data)
    }
  }
  if (selected_lng == null) {
    let data = localStorage.getItem("lng")
    if (data && data !== "null" && data !== undefined) {
      selected_lng = JSON.parse(decode(data))
      // document.documentElement.lang = selected_lng.lng.toLowerCase()
    }
  }
  const key_word = _key_word.toLowerCase() == undefined ? _key_word : _key_word.toLowerCase()
  var lng_key = selected_lng && selected_lng.lng ? selected_lng.lng.toLowerCase() : null
  if (
    translate_data &&
    translate_data[key_word] &&
    translate_data[key_word]["lng_" + lng_key + "_txt"]
  ) {
    return translate_data[key_word]["lng_" + lng_key + "_txt"]
  }
  return (keyIsTH ? _key_word + "*" : "[org]" + key_word)

}

export default Language
